import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", location.pathname);
    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        applyAuth(data);
        toast.success(`Signed in as ${data.user.name}`);
        navigate(data.user.role === "superadmin" ? "/admin" : "/dashboard", { replace: true });
      })
      .catch((err) => {
        toast.error(errorMessage(err));
        navigate("/login", { replace: true });
      });
  }, [location, navigate, applyAuth]);

  return (
    <div data-testid="auth-callback" className="min-h-screen grid place-items-center grid-bg">
      <div className="text-center"><Loader2 className="mx-auto animate-spin text-emerald-700" size={32} /><p className="mt-4 text-sm text-muted-foreground">Completing Google sign-in…</p></div>
    </div>
  );
}
